export const EXCMTEAMUSERDATA_SHOW_RESET = 'EXCMTEAMUSERDATA_SHOW_RESET'
export const EXCMTEAMUSERDATA_SHOW_SET_ERROR = 'EXCMTEAMUSERDATA_SHOW_SET_ERROR'
export const EXCMTEAMUSERDATA_SHOW_SET_RETRIEVED = 'EXCMTEAMUSERDATA_SHOW_SET_RETRIEVED'
export const EXCMTEAMUSERDATA_SHOW_TOGGLE_LOADING = 'EXCMTEAMUSERDATA_SHOW_TOGGLE_LOADING'
